const priceWrapper = document.querySelector('.price-wrapper');

// Check if element exists
if (priceWrapper) {
  // Create a mutation observer
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      console.log('Child nodes changed');
      
      //Change Loyatly Points
      var pointsSpan = document.querySelector('.loyalty-points-span');
      var salePrice = document.querySelector('.price-item.price-item--sale');
      var price = document.querySelector('.price-item.price-item--regular');
      var newPoints = 0;
      if(salePrice){
        salePriceFloat = parseFloat(salePrice.innerText.replace(/[$,\s]/g, ''));
        newPoints = loyaltyMultiplier * Math.floor(salePriceFloat);
      }else{
        priceFloat = parseFloat(price.innerText.replace(/[$,\s]/g, ''));
        newPoints = loyaltyMultiplier * Math.floor(priceFloat);
      }

      console.log('New Points: ' + newPoints);
      pointsSpan.innerText = newPoints;

      // Your custom code here
    });
  });

  // Configuration - only watch childList
  const config = {
    childList: true
  };

  // Start observing
  observer.observe(priceWrapper, config);
} else {
  console.error('Element with class "price-wrapper" not found');
}

var pointsSpan = document.querySelector('.loyalty-points-span');
var salePrice = document.querySelector('.price-item.price-item--sale');
var price = document.querySelector('.price-item.price-item--regular');
var newPoints = 0;
if(salePrice){
  salePriceFloat = parseFloat(salePrice.innerText.replace(/[$,\s]/g, ''));
  newPoints = loyaltyMultiplier * Math.floor(salePriceFloat);
}else{
  priceFloat = parseFloat(price.innerText.replace(/[$,\s]/g, ''));
  newPoints = loyaltyMultiplier * Math.floor(priceFloat);
}

//console.log('New Points: ' + newPoints);
pointsSpan.innerText = newPoints;